import { SimpleTooltip } from '../../../../../../shared/frontend/components/presentational/tooltip';

export function NumberOrNotAvailable(props: any) {
  if (props.num > 0) {
    return <span>{props.num}</span>;
  } else {
    return (
      <SimpleTooltip
        placement="right"
        tooltip={
          <span>
            <i className="fa fa-exclamation-triangle" /> &nbsp;Not tracked at original scan
          </span>
        }
      >
        <span className="slds-text-body--small text-muted">N/A</span>
      </SimpleTooltip>
    );
  }
}
